import Tabs from "../shared/Tabs";
import ViewFormInfo from "./ViewFormInfo";
import Delete from "../shared/Delete";
import { DELETE_FORM_DATA } from "./query";
import { ROUTE_AUTH_APP_LIST } from "../../utils";

const SubComponent = ({ data, appName }) => {
    const cacheName =
        (appName === ROUTE_AUTH_APP_LIST.ABBVIEPRO && "abbvieProSystemSettingByFormKey") ||
        (appName === ROUTE_AUTH_APP_LIST.ALLERGANPRO && "allerganProSystemSettingByFormKey");

    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${data.id}`,
                    name: "View",
                    content: <ViewFormInfo data={data} />,
                },
                {
                    id: `delete-${data.id}`,
                    name: "Delete",
                    content: (
                        <Delete
                            title="Form Data"
                            id={data.id}
                            query={DELETE_FORM_DATA}
                            cacheName={cacheName}
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
